import 'react-circular-progressbar/dist/styles.css';
import { useHistory } from 'react-router-dom';
import Layout from '../../components/layout';
export default function Dashboard() {
 const history=useHistory()

  return (
   
<Layout>
  <div style={{
    padding: "2rem",
    maxWidth: "600px",
    margin: "auto"
  }}>
    <h2 style={{
      textAlign: "center",
      marginBottom: "2rem",
      color: "#333"
    }}>
      Dashboard
    </h2>

    <div style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "1rem"
    }}>

      {/* Bookings Button */}
      {/* <div style={{
        flex: 1,
        minWidth: "200px",
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        padding: "0.5rem",
        textAlign: "center",
        borderLeft: "5px solid #719879",
        transition: "transform 0.2s ease",
      }}
      onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.03)"}
      onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}>
        <button style={{
          padding: "0.6rem 1.2rem",
          backgroundColor: "white",
          color: "#719879",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "1.3rem",
          transition: "background-color 0.3s ease"
        }}
        onClick={() => history.push('/booking/existing')}>
          Existing Customer
        </button>
      </div> */}

      {/* Payments Button */}
      <div style={{
        flex: 1,
        minWidth: "200px",
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        padding: "0.5rem",
        textAlign: "center",
        borderLeft: "5px solid #719879",
        transition: "transform 0.2s ease"
      }}
      onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.03)"}
      onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}>

        <button style={{
          padding: "0.6rem 1.2rem",
          backgroundColor: "white",
          color: "#719879",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "1.3rem",
          transition: "background-color 0.3s ease"
        }}
        onClick={() =>history.push('/payment/add')}>
          Add new Booking
        </button>
      </div>

    </div>
  </div>
</Layout>
  );
}
